export default "__VITE_ASSET__iVXQC12u__"